export enum TabNames {
  CHATBOTS = "chatbots",
  LOREBOOKS = "lorebooks",
  GROUPS = "groupchats",
  VOICES = "voices",
}
